// Pixel-art prop drawers. All props are anchored to the floor line F.
export const W = 320, H = 180, F = 145, CEIL = 22;

export const R = (ctx, c, x, y, w, h) => {
  ctx.fillStyle = c;
  ctx.fillRect(Math.round(x), Math.round(y), w, h);
};

const WOOD = "#3b2516", WOOD_L = "#5a3a22", WOOD_D = "#24160c";

export const PROPS = {
  bed: (c, x, p) => {
    const w = p.w || 48;
    R(c, WOOD, x, F - 30, 4, 30); R(c, WOOD, x, F - 12, w, 8); R(c, WOOD_D, x + 2, F - 4, 3, 4); R(c, WOOD_D, x + w - 4, F - 4, 3, 4);
    R(c, "#cfc7b8", x + 3, F - 17, w - 4, 5); R(c, "#e8e2d6", x + 5, F - 20, 9, 4);
    R(c, "#5a1a1a", x + 15, F - 18, w - 16, 7); R(c, "#431212", x + 15, F - 12, w - 16, 1);
  },
  table: (c, x, p) => {
    const w = p.w || 50;
    R(c, WOOD_L, x, F - 21, w, 3); R(c, WOOD_D, x, F - 18, w, 1);
    R(c, WOOD, x + 2, F - 18, 3, 18); R(c, WOOD, x + w - 5, F - 18, 3, 18);
    R(c, "#e7e0c9", x + w / 2 - 1, F - 27, 2, 6); R(c, "#f59e0b", x + w / 2 - 1, F - 29, 2, 2);
  },
  chair: (c, x, p) => {
    const bx = p.flip ? x + 8 : x;
    R(c, WOOD, bx, F - 26, 2, 26); R(c, WOOD_L, x, F - 12, 10, 2); R(c, WOOD, x + (p.flip ? 0 : 8), F - 10, 2, 10);
  },
  stove: (c, x) => {
    R(c, "#2a2a2e", x, F - 28, 26, 28); R(c, "#3d3d42", x, F - 30, 26, 2); R(c, "#111", x + 3, F - 30, 6, 1); R(c, "#111", x + 16, F - 30, 6, 1);
    R(c, "#0c0c0c", x + 4, F - 21, 18, 11); R(c, "#7a7a80", x + 4, F - 24, 18, 1);
  },
  fridge: (c, x) => {
    R(c, "#a8a495", x, F - 50, 22, 50); R(c, "#7d7a6e", x, F - 34, 22, 1); R(c, "#555", x + 18, F - 46, 2, 8); R(c, "#555", x + 18, F - 30, 2, 10);
    R(c, "#f5f5dc", x + 5, F - 44, 7, 6);
  },
  counter: (c, x) => {
    R(c, "#3b2a1e", x, F - 22, 44, 22); R(c, "#6b6b6b", x - 1, F - 24, 46, 3);
    R(c, "#2a1d14", x + 21, F - 20, 1, 18); R(c, "#7a6a5a", x + 17, F - 14, 2, 2); R(c, "#7a6a5a", x + 25, F - 14, 2, 2);
    R(c, "#3b2a1e", x, F - 74, 44, 18); R(c, "#2a1d14", x + 21, F - 72, 1, 14); R(c, "#999", x + 6, F - 28, 1, 4);
  },
  sink: (c, x) => {
    R(c, "#d8d8d0", x + 4, F - 20, 6, 20); R(c, "#e6e6df", x, F - 26, 14, 6); R(c, "#9aa", x + 6, F - 30, 2, 4);
    R(c, "#4a3a2a", x - 1, F - 62, 16, 22); R(c, "#7f9aa3", x + 1, F - 60, 12, 18);
    R(c, "#cfe", x + 3, F - 58, 1, 6); R(c, "#2a3a3f", x + 7, F - 60, 1, 7); R(c, "#2a3a3f", x + 8, F - 53, 1, 6); R(c, "#2a3a3f", x + 6, F - 47, 1, 5);
  },
  toilet: (c, x) => {
    R(c, "#e6e6df", x + 9, F - 26, 7, 14); R(c, "#d8d8d0", x, F - 13, 15, 5); R(c, "#c8c8c0", x + 3, F - 8, 9, 8);
  },
  tub: (c, x) => {
    R(c, "#d8d8d0", x, F - 18, 50, 14); R(c, "#efefe8", x - 1, F - 19, 52, 2); R(c, "#a0a098", x + 4, F - 4, 4, 4); R(c, "#a0a098", x + 42, F - 4, 4, 4);
    R(c, "#888", x + 46, F - 34, 2, 15); R(c, "#888", x + 42, F - 34, 5, 2);
  },
  fireplace: (c, x, p, t) => {
    R(c, "#4a4a4f", x, F - 46, 44, 46); for (let i = 0; i < 6; i++) R(c, "#3a3a3f", x + (i % 2) * 10 + 2, F - 44 + i * 7, 18, 1);
    R(c, "#140606", x + 9, F - 26, 26, 26); R(c, WOOD_D, x - 3, F - 48, 50, 4);
    for (let i = 0; i < 7; i++) {
      const h = 6 + Math.abs(Math.sin(t / 120 + i * 1.7)) * 9;
      R(c, i % 2 ? "#f59e0b" : "#dc2626", x + 11 + i * 3, F - 3 - h, 3, h);
    }
    R(c, "#fde68a", x + 18, F - 8, 8, 4); R(c, "#2a160a", x + 12, F - 3, 20, 3);
  },
  couch: (c, x) => {
    R(c, "#4a2323", x, F - 24, 54, 10); R(c, "#5c2b2b", x, F - 15, 54, 10); R(c, "#3a1a1a", x - 4, F - 19, 6, 15); R(c, "#3a1a1a", x + 52, F - 19, 6, 15);
    R(c, "#3a1a1a", x + 26, F - 15, 1, 8); R(c, WOOD_D, x, F - 5, 3, 5); R(c, WOOD_D, x + 51, F - 5, 3, 5);
  },
  bookshelf: (c, x) => {
    R(c, WOOD, x, F - 72, 30, 72);
    const cols = ["#7f1d1d", "#1e3a5f", "#3f3f1f", "#4a2c4a", "#2f4f3f", "#6b4f1f"];
    for (let s = 0; s < 5; s++) {
      const sy = F - 70 + s * 14;
      R(c, WOOD_D, x + 2, sy, 26, 12);
      for (let b = 0; b < 7; b++) { const bh = 8 + ((b * 7 + s * 3) % 4); R(c, cols[(b + s * 2) % 6], x + 3 + b * 3.5, sy + 12 - bh, 3, bh); }
    }
  },
  desk: (c, x) => {
    R(c, WOOD_L, x, F - 23, 40, 3); R(c, WOOD, x + 26, F - 20, 14, 20); R(c, WOOD_D, x + 28, F - 14, 10, 1); R(c, WOOD, x, F - 20, 3, 20);
    R(c, "#f5f5dc", x + 8, F - 25, 8, 2); R(c, "#111", x + 20, F - 29, 3, 6);
  },
  lamp: (c, x) => {
    R(c, "#2a2a2a", x + 3, F - 40, 2, 40); R(c, "#1a1a1a", x, F - 2, 8, 2); R(c, "#c9a85c", x - 1, F - 48, 10, 8); R(c, "#fde68a", x + 1, F - 41, 6, 1);
  },
  dresser: (c, x) => {
    R(c, "#4a2e1b", x, F - 30, 32, 30); for (let i = 0; i < 3; i++) { R(c, WOOD_D, x + 2, F - 28 + i * 9, 28, 1); R(c, "#a07a40", x + 15, F - 24 + i * 9, 2, 2); }
    R(c, "#3a2414", x + 2, F - 50, 28, 18); R(c, "#6f8a93", x + 4, F - 48, 24, 14);
  },
  rocker: (c, x, p, t) => {
    const o = Math.sin(t / 600) * 1.5;
    R(c, WOOD, x + 2 + o, F - 30, 2, 22); R(c, WOOD_L, x + 2, F - 12, 14, 2); R(c, WOOD, x + 14, F - 10, 2, 7); R(c, WOOD, x + 3, F - 10, 2, 7);
    R(c, WOOD_D, x - 1, F - 3, 20, 2);
  },
  toybox: (c, x) => {
    R(c, "#6b3a2a", x, F - 16, 28, 16); R(c, "#8a4a35", x - 1, F - 18, 30, 3); R(c, "#d4a24c", x + 12, F - 12, 4, 3);
    R(c, "#e7d8b5", x + 4, F - 26, 8, 8); R(c, "#000", x + 6, F - 24, 1, 1); R(c, "#000", x + 9, F - 24, 1, 1);
  },
  tv: (c, x, p, t) => {
    R(c, WOOD, x, F - 14, 30, 14); R(c, "#1f1f22", x + 2, F - 36, 26, 22); R(c, "#111", x + 4, F - 34, 18, 18);
    for (let i = 0; i < 24; i++) { const v = (Math.sin(i * 91.7 + t * 0.07) * 43758.5) % 1; R(c, Math.abs(v) > 0.5 ? "#777" : "#333", x + 4 + (i % 6) * 3, F - 34 + Math.floor(i / 6) * 4.5, 3, 4); }
    R(c, "#555", x + 24, F - 32, 2, 2); R(c, "#555", x + 24, F - 27, 2, 2);
  },
  painting: (c, x, p, t) => {
    R(c, "#5a3d1e", x, 58, 22, 18); R(c, "#1a1414", x + 2, 60, 18, 14); R(c, "#3a2a2a", x + 7, 63, 8, 11);
    if (Math.sin(t / 900) > 0.92) { R(c, "#dc2626", x + 9, 65, 1, 1); R(c, "#dc2626", x + 12, 65, 1, 1); }
  },
  clock: (c, x, p, t) => {
    R(c, WOOD, x, F - 62, 14, 62); R(c, WOOD_D, x - 1, F - 64, 16, 3); R(c, "#d8d0b0", x + 3, F - 58, 8, 8); R(c, "#111", x + 7, F - 57, 1, 4);
    R(c, "#111", x + 3, F - 46, 8, 26); R(c, "#b08d3a", x + 6 + Math.sin(t / 500) * 1.5, F - 44, 2, 20);
  },
  coatrack: (c, x) => {
    R(c, WOOD, x + 3, F - 50, 2, 50); R(c, WOOD, x - 2, F - 2, 12, 2); R(c, "#2a3a2a", x - 2, F - 48, 6, 20); R(c, "#3a2a1a", x + 4, F - 46, 5, 14);
  },
  rug: (c, x, p) => { const w = p.w || 100; R(c, "#4a1a1a", x, F + 4, w, 6); R(c, "#6b2a2a", x + 3, F + 5, w - 6, 1); R(c, "#6b2a2a", x + 3, F + 8, w - 6, 1); },
  ceilinglamp: (c, x, p, t) => { R(c, "#222", x, CEIL, 1, 10); R(c, "#4a4a3a", x - 4, CEIL + 10, 9, 4); R(c, Math.random() > 0.03 ? "#fde68a" : "#555", x - 2, CEIL + 14, 5, 1); },
  chandelier: (c, x, p, t) => {
    R(c, "#222", x, CEIL, 1, 14); R(c, "#6b5a2a", x - 14, CEIL + 14, 29, 2);
    for (let i = 0; i < 4; i++) { R(c, "#6b5a2a", x - 13 + i * 9, CEIL + 10, 1, 4); R(c, Math.sin(t / 80 + i) > -0.8 ? "#fbbf24" : "#7a5a1a", x - 13 + i * 9, CEIL + 8, 1, 2); }
  },
  bulb: (c, x) => { R(c, "#111", x, CEIL, 1, 16); R(c, "#e5d38a", x - 1, CEIL + 16, 3, 3); },
  boxes: (c, x) => {
    R(c, "#6b5034", x, F - 16, 22, 16); R(c, "#5a4128", x + 20, F - 12, 18, 12); R(c, "#7a5c3c", x + 4, F - 28, 16, 12);
    R(c, "#4a3520", x + 10, F - 16, 2, 16); R(c, "#4a3520", x + 11, F - 28, 2, 12);
  },
  furnace: (c, x, p, t) => {
    R(c, "#3a3a3a", x, F - 52, 36, 52); R(c, "#2a2a2a", x + 4, F - 48, 28, 20); R(c, "#2a2a2a", x + 14, F - 82, 8, 30);
    for (let i = 0; i < 4; i++) R(c, "#111", x + 6, F - 46 + i * 5, 24, 2);
    R(c, Math.sin(t / 200) > 0 ? "#dc2626" : "#7f1d1d", x + 6, F - 20, 24, 6);
  },
  fusebox: (c, x) => {
    R(c, "#555a5e", x, 64, 18, 26); R(c, "#3a3e42", x + 2, 66, 14, 22);
    for (let i = 0; i < 3; i++) { R(c, "#9ca3af", x + 4, 69 + i * 6, 3, 3); R(c, i === 1 ? "#111" : "#9ca3af", x + 10, 69 + i * 6, 3, 3); }
    R(c, "#222", x + 8, 90, 2, F - 90);
  },
  shelf: (c, x) => {
    R(c, "#5a5a60", x, F - 56, 2, 56); R(c, "#5a5a60", x + 32, F - 56, 2, 56);
    for (let i = 0; i < 3; i++) R(c, "#6b6b72", x, F - 54 + i * 18, 34, 2);
    R(c, "#7f1d1d", x + 4, F - 64 + 18, 8, 10); R(c, "#3f3f1f", x + 20, F - 62 + 36, 10, 8); R(c, "#1e3a5f", x + 6, F - 8, 12, 8);
  },
  washer: (c, x) => { R(c, "#c8c8c0", x, F - 30, 26, 30); R(c, "#555", x + 6, F - 22, 14, 14); R(c, "#2a3a4a", x + 8, F - 20, 10, 10); R(c, "#999", x + 2, F - 28, 4, 2); },
  tree: (c, x) => {
    R(c, "#2a1a10", x + 8, F - 18, 5, 22);
    for (let i = 0; i < 5; i++) { const w = 6 + i * 5; R(c, i % 2 ? "#0f2a1f" : "#13342a", x + 10 - w / 2, F - 70 + i * 10, w, 10); R(c, "#d9e4ee", x + 10 - w / 2, F - 70 + i * 10, w, 2); }
  },
  stump: (c, x) => { R(c, "#3a2414", x, F - 8, 16, 10); R(c, "#d9e4ee", x - 1, F - 10, 18, 3); R(c, "#555", x + 6, F - 18, 2, 9); R(c, "#9ca3af", x + 2, F - 20, 8, 4); },
};
